module.exports = __webpack_public_path__ + "06_bob_gray.60c14f55.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/06_bob_gray.png
// module id = fVi/
// module chunks = 0